import { useEffect } from "react";
import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Scan from "@/pages/Scan";
import ScanResult from "@/pages/ScanResult";
import AscensionPlan from "@/pages/AscensionPlan";
import Battle from "@/pages/Battle";
import Leaderboard from "@/pages/Leaderboard";
import Guides from "@/pages/Guides";
import GuideDetail from "@/pages/GuideDetail";
import Profile from "@/pages/Profile";
import Coach from "@/pages/Coach";
import VIP from "@/pages/VIP";
import Chat from "@/pages/Chat";
import Events from "@/pages/Events";
import Peptides from "@/pages/Peptides";
import PaymentSuccess from "@/pages/PaymentSuccess";
import Owner from "@/pages/Owner";
import Referral from "@/pages/Referral";
import AppShell from "@/components/app/AppShell";
import MatrixRain from "@/components/app/MatrixRain";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-muted-foreground font-mono text-sm">LOADING...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <MatrixRain density={0.96} opacity={0.16} />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            {/* Affiliate invite link — public, first-touch capture */}
            <Route path="/r/:code" element={<Referral />} />
            {/* Owner console — unlisted route */}
            <Route path="/owner-console-x7k9" element={<Owner />} />
            {/* Stripe payment success — must be public (session ID in URL) */}
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route element={<Protected><AppShell /></Protected>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/scan" element={<Scan />} />
              <Route path="/scan/:id" element={<ScanResult />} />
              <Route path="/scan/:id/plan" element={<AscensionPlan />} />
              <Route path="/battle" element={<Battle />} />
              <Route path="/leaderboard" element={<Leaderboard />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/guides/:id" element={<GuideDetail />} />
              <Route path="/coach" element={<Coach />} />
              <Route path="/vip" element={<VIP />} />
              <Route path="/chat" element={<Chat />} />
              <Route path="/events" element={<Events />} />
              <Route path="/peptides" element={<Peptides />} />
              <Route path="/profile" element={<Profile />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-right"
          toastOptions={{
            style: {
              background: "#061008",
              border: "1px solid #1e4a28",
              color: "#d6ffd9",
              borderRadius: "2px",
              fontFamily: "JetBrains Mono, monospace",
              fontSize: "12px",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
